import React, {useEffect, useState, useRef} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPaperclip,
    faPaperPlane,
    faTrash,
    faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import { socket } from '../../../socket';
import Resizer from "react-image-file-resizer";
import '../Agent.css';
import ActionPopupMenu from './ActionPopupMenu';
import { MenuComponent } from '../../../../_template/assets/ts/components/MenuComponent';
import { Modal, AutoComplete, notification } from 'antd';

const AgentChatModal = (props) => {
    const [api, contextHolder] = notification.useNotification();
    const api_base_url = process.env.REACT_APP_API_URL;
    const agentInfo = JSON.parse(localStorage.getItem('agentInfo'));

    const [value, setValue] = useState("");
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState(null);
    const [selectedFile, setSelectedFile] = useState([]);

    const [modalOpen, setModalOpen] = useState(false);
    const [options, setOptions] = useState(props.agents);
    const [searchValue, setSearchValue] = useState('');
    const [selectedAgent, setSelectedAgent] = useState('');
    const [isSessionEnd, setIsSessionEnd] = useState(false);

    const fileInputRef = useRef(null);

    const messagesEndRef = useRef();

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        scrollToBottom()
    }, [messages]);

    useEffect(()=>{
        setOptions(props.agents);
    },[props.agents])

    useEffect(()=>{
        if(newMessage) {
            if(props.selectedUser.room == newMessage.room) {
                setMessages((prevMessages) => [...prevMessages, newMessage]);
            }
        }
    },[newMessage])

    useEffect(() => {
        props.selectedUser.session_id = props.selectedUser.sessionId;
        selectChatUser(props.selectedUser);
    }, [props.selectedUser, isSessionEnd]);

    useEffect(() => {
        document.body.setAttribute('data-sai-drawer-chat', 'on');
        document.body.setAttribute('data-sai-drawer', 'on');
        socket.connect();
        
        socket.on("received_message", (newMessage)=>{
            if(newMessage.data.length > 0) {
                setNewMessage(newMessage.data[0])
                // if(newMessage.data[0].room == props.selectedUser.room) {
                //     setMessages((prevMessages) => [...prevMessages, newMessage.data[0]]);
                // }
            }
        });
        socket.on("user_remove", (data)=>{
            if(data) {
                if(data.room === props.selectedUser.room) {
                    props.selectedUser.session_end = "Y";
                }
            }
        });

        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500);
        
        return () => {
            socket.off("received_message");
            socket.off("user_remove");
            socket.disconnect();
        };
    }, []);

    const formSubmitHandler = async(e) => {
        e.preventDefault();
        const msg_type = selectedFile.length > 0 ? 'file' : 'text';
        const formData = new FormData();
        formData.append("chatSession", props.selectedUser.session_id);
        formData.append("chatRoom", props.selectedUser.room);
        formData.append("sender_id", agentInfo.unique_id);
        formData.append("receiver_id", props.selectedUser.receiver_id);
        formData.append("message", value);
        formData.append("type", msg_type);
        selectedFile.forEach(({ file }) => {
            formData.append("chatFile[]", file); // Append all selected files
        });

        const api_headers = {
            headers: { 
                //"Content-Type": "application/json",
                //"Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };
        
        await axios.post(`${api_base_url}agent/send-message`, formData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setValue('');
                    setSelectedFile([]);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const textareaPressed = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            formSubmitHandler(event);
        }
    }

    const selectChatUser = async(user) => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };

        const form_data = {
            chatSessionId: user.session_id,
            chatRoom: user.room,
            sender_id: user.sender_id,
            receiver_id: user.receiver_id
        }

        await axios.post(`${api_base_url}agent/get-activated-chat`, form_data, api_headers)
            .then(async (res) => {
                setMessages([]);
                if(res.data.status === 'success') {
                    setMessages(res.data.data.message.reverse());
                    if(res.data.data.chatsession.length > 0) {
                        props.selectedUser.session_end = res.data.data.chatsession[0].session_end;
                        props.selectedUser.room = res.data.data.chatsession[0].room;
                        props.selectedUser.session_id = res.data.data.chatsession[0].session_id;
                        props.selectedUser.receiver_id = res.data.data.chatsession[0].receiver_id;
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const fileButtonClick = async() => {
        fileInputRef.current.click();
    }

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const resizedFiles = files.map((file) => {
            return new Promise((resolve) => {
                if (file.type.startsWith("image/")) {
                    Resizer.imageFileResizer(
                        file,
                        300, // Max width
                        300, // Max height
                        "JPEG", // Format
                        80, // Quality
                        0, // Rotation
                        (uri) => {
                            fetch(uri)
                                .then((res) => res.blob())
                                .then((blob) => {
                                    const resizedFile = new File([blob], file.name, { type: file.type });
                                    resolve({ file: resizedFile, preview: URL.createObjectURL(resizedFile) });
                                });
                        },
                        "base64"
                    );
                } else {
                    resolve({ file, preview: URL.createObjectURL(file) });
                }
            });
        });

        Promise.all(resizedFiles).then((updatedFiles) => {
            setSelectedFile((prevFiles) => [...prevFiles, ...updatedFiles]); // Append new files
        });
    };

    const handleRemoveFile = (index) => {
        setSelectedFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const popupFunction = (type) => {
        if(type == 'transfer') {
            setModalOpen(true);
        } else {
            endSession();
        }
    }
    
    const closeModal = () => {
        setModalOpen(false);
        setSelectedAgent('');
        setSearchValue('');
    };

    const transferToAgent = async () => {
        if(selectedAgent) {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('agenttoken')
                }
            };
    
            const form_data = {
                sender_id: agentInfo.unique_id,
                agent_id: selectedAgent.value,
                receiver_id: props.selectedUser.receiver_id,
                chat_room: props.selectedUser.room,
                socketId: '',
                chatSession: props.selectedUser.session_id
            };

            await axios.post(`${api_base_url}agent/transfer-to-agent`, form_data, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    api["success"]({
                        message: 'Success',
                        description: "Chat transfer successfull."
                    });

                    setModalOpen(false);
                    setSelectedAgent('');
                    setSearchValue('');

                    props.selectedUser.session_end = "Y";
                }
            })
            .catch((error) => {
                console.error(error);
            });
        }
    }

    const endSession = async() => {
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : localStorage.getItem('agenttoken')
            }
        };

        const form_data = {
            chat_room: props.selectedUser.room,
            chatSession: props.selectedUser.session_id
        };

        await axios.post(`${api_base_url}agent/close-current-session`, form_data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                api["success"]({
                    message: 'Success',
                    description: "Chat transfer successfull."
                });

                props.selectedUser.session_end = "Y";
                //setIsSessionEnd(true);
                props.liveUsers.map(user =>
                    user.session_id === form_data.chatSession
                      ? { ...user, session_end: 'Y' }
                      : user
                )
            }
        })
        .catch((error) => {
            console.error(error);
        });
    }
    //////////////////////////////////////////////
    const onSelect = (data, option) => {
        setSelectedAgent(option);
        setSearchValue(option.label);
    };
    
    const onChange = (data, option) => {
        setSearchValue(data);
        setSelectedAgent(option);
    };

    return (
        <>
        <div
        id='sai_drawer_chat'
        className='bg-body'
        >
            <div className='card w-100 rounded-0'>
                <div className='card-body bg-light'>
                    <div className='row'>
                        {props.liveUsers.length > 0 && <div className="col-md-5">
                            <div className="card h-xl-100">
                                <div className="card-header border-0 pt-5">
                                    <h3 className="card-title align-items-start flex-column">
                                        <span className="card-label fw-bold text-dark">Latest conversation</span>
                                        <span className="text-muted mt-1 fw-semibold fs-7">{props.liveUsers.length} social visitors</span>
                                    </h3>
                                </div>
                                <div className="card-body pt-6">
                                    {props.liveUsers.map((item, index)=>(
                                        <div key={index}>
                                            <div className={`d-flex flex-stack cursor-pointer ${props.selectedUser.room == item.room ? 'active-user' : ''}`} onClick={() => selectChatUser(item)}>
                                                <div className="symbol symbol-35px me-4">
                                                    <div className="symbol-label fs-2 fw-semibold bg-primary text-inverse-primary">U</div>
                                                </div>
                                                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                    <div className="flex-grow-1 me-2">
                                                        <a className="text-gray-800 text-hover-primary fs-6 fw-bold">Unknown</a>
                                                        <span className="text-muted fw-semibold d-block fs-7">
                                                            {item.user_source}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {index != (props.liveUsers.length - 1) && <div className="separator separator-dashed my-4"></div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>}
                        <div className={`${props.liveUsers.length > 0 ? 'col-md-7' : 'col-md-12'}`}>
                            <div className="card h-xl-100" id="sai_drawer_chat_messenger">
                                <div className="card-header pe-5">
                                    <div className="card-title">
                                        <div className="d-flex justify-content-center flex-column me-3">
                                            <a href="#" className="fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1">{props.selectedUser.user_source ? props.selectedUser.user_source : 'Unknown'}</a>
                                            <div className="mb-0 lh-1">
                                                {props.selectedUser.session_end == "Y" && <span className="badge badge-danger badge-circle w-10px h-10px me-1"></span>}
                                                {props.selectedUser.session_end != "Y" && <span className="badge badge-success badge-circle w-10px h-10px me-1"></span>}
                                                <span className="fs-7 fw-semibold text-muted">{props.selectedUser.session_end == "Y" ? 'Inactive':'Active'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* props.selectedUser.session_end != "Y" && */}
                                    {props.selectedUser.session_end != "Y" && <>
                                        <div className="btn btn-dark btn-icon btn-sm mt-5"
                                        data-sai-menu-trigger='click'
                                        data-sai-menu-placement='bottom-end'
                                        data-sai-menu-flip='top-end'>
                                            <FontAwesomeIcon className='fs-3' icon={faEllipsisVertical} />
                                        </div>
                                        <ActionPopupMenu clickHandler={popupFunction} /> 
                                    </>}
                                </div>
                                <div className="card-body" id="sai_drawer_chat_messenger_body">
                                    {selectedFile.length == 0 && <div className="scroll-y me-n5 pe-5 scroll-height">
                                        {messages.map((msg, index) => (
                                            <div key={index}>
                                                {msg.sender_id != agentInfo.unique_id && <div className="d-flex justify-content-start mb-3">
                                                    <div className="d-flex flex-column align-items-start">
                                                        <div className="p-3 rounded bg-light-info text-dark fw-semibold mw-lg-400px text-start">
                                                            <div>
                                                                {msg.msg_body}
                                                            </div>
                                                            
                                                            {msg.file_data.length > 0 && msg.file_data.map((file, file_index) => ( <img src={file.filePath} className="m-1 rounded" style={{ width: "100px", height: "100px", objectFit: "cover" }} key={file_index} />))}
                                                        </div>
                                                    </div>
                                                </div>}
                                                {msg.sender_id == agentInfo.unique_id && <div className="d-flex justify-content-end mb-3">
                                                    <div className="d-flex flex-column align-items-end">
                                                        <div className="p-3 rounded bg-light-primary text-dark fw-semibold mw-lg-400px text-end">
                                                            <div>
                                                                {msg.msg_body}
                                                            </div>
                                                            
                                                            {msg.file_data.length > 0 && msg.file_data.map((file, file_index) => ( <img src={file.filePath} className="m-1 rounded" style={{ width: "100px", height: "100px", objectFit: "cover" }} key={file_index} />))}
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        ))}
                                        <div ref={messagesEndRef} />
                                    </div>}
                                    {selectedFile.length > 0 && <div className='d-flex justify-content-end mb-3'>
                                        {selectedFile.map(({ file, preview }, index)=>(
                                            <div className='p-2 position-relative' key={index} style={{ display: "inline-block" }}>
                                                <img src={preview} className="me-2 rounded" style={{ width: "100px", height: "100px", objectFit: "cover" }}  />

                                                <div className="cursor-pointer position-absolute top-0 end-0 p-1 bg-light rounded-circle shadow" onClick={()=> handleRemoveFile(index)} style={{ transform: "translate(-10%, -10%)" }}>
                                                    <FontAwesomeIcon className='fs-3' icon={faTrash} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                                {props.selectedUser.session_end != "Y" && <div className="card-footer p-3" id="sai_drawer_chat_messenger_footer">
                                    <form onSubmit={formSubmitHandler}>
                                        <textarea className="form-control form-control-flush mb-3" rows="1" data-kt-element="input" placeholder="Type a message" name="message" onKeyDown={textareaPressed} onChange={(e) => setValue(e.target.value)} value={value}></textarea>
                                        <input type="file" className='d-none' name="chatfile[]" ref={fileInputRef} onChange={handleFileChange} multiple/>
                                        <div className="d-flex flex-stack">
                                            <div className="d-flex align-items-center me-2">
                                                <button className="btn btn-sm btn-icon btn-active-light-primary me-1" type="button" onClick={fileButtonClick}>
                                                    <FontAwesomeIcon className='fs-3' icon={faPaperclip} />
                                                </button>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                                <button className="btn btn-sm btn-icon btn-active-light-primary me-1" type="submit">
                                                    <FontAwesomeIcon className='fs-3' icon={faPaperPlane} />
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal
            open={modalOpen}
            title="Transfer to Agent"
            footer={() => (
            <>
                <button className='btn btn-light me-4' onClick={closeModal}>Close</button>
                <button className='btn btn-dark' onClick={transferToAgent}>Transfer</button>
            </>
            )}
        >
            <AutoComplete
                value={searchValue}
                options={options}
                style={{ width: '100%', height: 40 }}
                placeholder="Type agent name"
                filterOption={(inputValue, option) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                }
                onSelect={onSelect}
                onChange={onChange}
            />
        </Modal>
        {contextHolder} 
        </>
    )
}

export default AgentChatModal;